module.exports = __webpack_public_path__ + "img/hourly.dc6f83b5.svg";